import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@material-ui/core';
import {
  QUEUE_STATUS,
  REVIEW_STATUS,
  getReviewStatusLabel,
  isResolvedStatus,
} from '../../constants/lms-course-review.constants';

const FALLBACK_LABELS = {
  [QUEUE_STATUS.PENDING]: { label: 'Pending', color: 'default' },
  [QUEUE_STATUS.RESOLVED]: { label: 'Resolved', color: 'primary' },
};

const getChipConfig = (reviewStatus, status) => {
  if (reviewStatus) {
    const label = getReviewStatusLabel(reviewStatus);
    if (label !== reviewStatus) {
      const color = reviewStatus === REVIEW_STATUS.PENDING.key ? 'default' : 'primary';
      return { label, color };
    }
    if (isResolvedStatus(reviewStatus)) {
      return { label: reviewStatus.replace(/_/g, ' '), color: 'primary' };
    }
  }
  return FALLBACK_LABELS[status] || { label: status || reviewStatus, color: 'default' };
};

const QueueStatusChip = ({ reviewStatus, status }) => {
  const config = getChipConfig(reviewStatus, status);
  const testId = reviewStatus || status;
  return (
    <Chip
      size="small"
      label={config.label}
      color={config.color}
      data-testid={`status-chip-${testId}`}
    />
  );
};

QueueStatusChip.propTypes = {
  reviewStatus: PropTypes.string,
  status: PropTypes.string,
};

QueueStatusChip.defaultProps = {
  reviewStatus: undefined,
  status: undefined,
};

export default QueueStatusChip;
